import { Badge, IconButton } from "@mui/material";
import ChatIcon from "@mui/icons-material/Chat";
import { useMessenger } from "./MessengerContext";

export default function MessengerHeaderButton() {
  const { totalUnread } = useMessenger();

  return (
    <IconButton
      aria-label="Open messenger"
      color="primary"
      onClick={() =>
        window.dispatchEvent(new CustomEvent("rcm-messenger-drawer-toggle"))
      }
    >
      <Badge
        badgeContent={totalUnread}
        color="error"
        max={99}
        invisible={!totalUnread}
      >
        <ChatIcon sx={{ fontSize: "1.75rem" }} />
      </Badge>
    </IconButton>
  );
}
